"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const List_1 = tslib_1.__importDefault(require("@mui/material/List"));
const ListItemButton_1 = tslib_1.__importDefault(require("@mui/material/ListItemButton"));
const ListItemIcon_1 = tslib_1.__importDefault(require("@mui/material/ListItemIcon"));
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const Popover_1 = tslib_1.__importDefault(require("@mui/material/Popover"));
const colors_1 = require("../colors");
const ArgusMenuLink_1 = tslib_1.__importDefault(require("./ArgusMenuLink"));
const IconComponent_1 = tslib_1.__importDefault(require("./IconComponent"));
const StyledListItem_1 = tslib_1.__importDefault(require("./StyledListItem"));
const useBreakpoints_1 = require("./useBreakpoints");
const ArgusMenuDropdown = ({ iconId, items, label, logger, ListItemProps, ListItemButtonProps, ListItemIconProps, ListItemTextProps, }) => {
    const ref = (0, react_1.useRef)();
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const { isDesktop } = (0, useBreakpoints_1.useBreakpoints)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledListItem_1.default, { ref: ref, ...ListItemProps },
            react_1.default.createElement(ListItemButton_1.default, { ...ListItemButtonProps, onClick: (e) => {
                    setAnchorEl(ref.current);
                    if (ListItemButtonProps?.onClick) {
                        ListItemButtonProps?.onClick(e);
                    }
                } },
                react_1.default.createElement(ListItemIcon_1.default, { ...{ sx: { minWidth: 0, marginRight: 1 }, ...ListItemIconProps } },
                    react_1.default.createElement(IconComponent_1.default, { ...{ iconId, logger, sx: { color: "primary.contrastText", height: "1.2em", width: "1.2em" } } })),
                isDesktop && (react_1.default.createElement(ListItemText_1.default, { ...{
                        primary: label,
                        sx: { color: "primary.contrastText" },
                        primaryTypographyProps: { variant: "button" },
                        ...ListItemTextProps,
                    } })),
                react_1.default.createElement(IconComponent_1.default, { ...{
                        logger,
                        iconId: `dropdown-${anchorEl ? "up" : "down"}`,
                        sx: { color: "primary.contrastText" },
                    } }))),
        react_1.default.createElement(Popover_1.default, { ...{
                elevation: 0,
                TransitionProps: { timeout: 0 },
                onClose: () => setAnchorEl(null),
                open: Boolean(anchorEl),
                anchorEl,
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                transformOrigin: { vertical: "top", horizontal: "left" },
                PaperProps: { sx: { borderRadius: 0 } },
            } },
            react_1.default.createElement(List_1.default, { component: "div", sx: {
                    p: 0,
                    bgcolor: colors_1.black["800"],
                    borderRadius: 0,
                } }, items.map((item) => {
                return (react_1.default.createElement(ArgusMenuLink_1.default, { key: item?.label, disableShrinking: true, ...{
                        logger,
                        ListItemTextProps: { primaryTypographyProps: { variant: "body2" } },
                        ListItemButtonProps: {
                            style: { alignItems: "end" },
                        },
                        ...item,
                    } }));
            })))));
};
exports.default = ArgusMenuDropdown;
